module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN211_1167526193.3f97c2d0.png";